export const OFFICIAL_SLOGAN = "Скуштуй Азію на смак!" as const;
export const STORE_NAME_UA = "Скарби Азії" as const;
export const BRAND_INTERNATIONAL = "AsiaStyle" as const;

export const brandConfig = {
  storeNameUa: STORE_NAME_UA,
  brandInternational: BRAND_INTERNATIONAL,
  slogan: OFFICIAL_SLOGAN,
} as const;
